import { createContext, useContext } from 'react';

// Rental mode (mid-uhy.18): the buyer's mode as cockpit_summary.mode reports it
// ({ active_mode, modes: { buy: { complete }, rent: { complete } } }) plus
// switchMode(mode) -> Promise<boolean> and `switched`, the mode switched to this
// session (null until the first switch). Null while the rental_mode flag is off
// (the summary carries no mode) and for anyone who is not a buyer, so every mode
// surface hides on null. BuyerModeProvider.js owns it; this module stays import-free so
// any component can read the names.
export const BuyerModeContext = createContext(null);

export const useRentMode = () => useContext(BuyerModeContext)?.active_mode === 'rent';

// Rental mode (mid-uhy.23): the product names a renter reads (brief section 5). Buyers,
// and every surface outside the cockpit shell, keep the buyer names.
const BUYER_NAMES = { dna: 'Buyer DNA', readiness: 'Buyer Readiness Score' };
const RENTER_NAMES = { dna: 'Renter DNA', readiness: 'Renter Readiness Score' };
export const useModeNames = () => (useRentMode() ? RENTER_NAMES : BUYER_NAMES);
